module.exports = __webpack_public_path__ + "assets/img/3862123663c1c212609f9e5f83926a20.png";